import styled from 'styled-components';

export const Element = styled.div`
  background: #16345938;
  padding: 10px;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  height: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: none;
  box-shadow: 0 4px 20px rgba(26, 26, 46, 0.15);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 30px rgba(26, 26, 46, 0.25);
    transform: translateY(-4px);
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const TitleContainer = styled.div`
  flex: 1;
  text-align: left;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0;
  line-height: 1.3;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  margin-left: 15px;
  min-height: 60px;
`;

export const StatusAndExpirationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 8px;
`;

export const ExpirationMessageBox = styled.strong`
  color: #4b5563;
  font-size: 12px;
  display: block;
  text-align: right;
`;
